module.exports = __webpack_public_path__ + "static/img/user-on.30302405.png";